<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="row">
        <div class="col-12" *ngIf="loading">
            <ngx-skeleton-loader [theme]="{
                        height: '244px',
                        margin:'0 0 24px'
                    }">
            </ngx-skeleton-loader>
        </div>

        <div class="col-12" *ngIf="!loading">
            <div class="dash-card card-padding-top">
                <app-empty-content [isVisible]="bonds.length === 0"
                    title="Nenhum vinculo encontrado"
                    description="Não foi encontrado nenhum vinculo nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <div class="dash-card-body" *ngIf="bonds.length > 0">
                    <div class="dash-card-scroll">
                        <table>
                            <thead>
                                <tr class="alternative-header">
                                    <th>Fundo</th>
                                    <th *ngIf="!isShareholder">Coobrigação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let bond of bonds">
                                    <td>
                                        <div class="dash-card-item">
                                            <div
                                                class="dash-card-item-initials">
                                                <span>{{getFundInitials(bond)}}</span>
                                            </div>

                                            <app-spacer
                                                [right]="16"></app-spacer>

                                            <div class="dash-card-item-content">
                                                <div
                                                    class="dash-card-item-content-title">
                                                    {{bond.name ??
                                                    bond.short_name}}
                                                </div>
                                                <div
                                                    class="dash-card-item-content-subtitle">
                                                    {{formatCnpj(bond.document)}}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="padding:0 10px"
                                        *ngIf="!isShareholder">
                                        {{bond.coobligation ? 'Sim' : 'Não'}}
                                    </td>
                                </tr>
                            </tbody>
                            <app-spacer [bottom]="28"></app-spacer>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <!-- Lado esquerdo - Versão Principal -->
    <div class="row">
        <div class="col-6">
            <ng-container *ngIf="mainLoading">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!mainLoading">
                <ng-container *ngIf="approvalService.approvalData.mainVersion">
                    <div class="dash-card card-padding-top">
                        <app-empty-content [isVisible]="mainBonds.length === 0"
                            title="Nenhum vinculo encontrado"
                            description="Não foi encontrado nenhum vinculo nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <div class="dash-card-body"
                            *ngIf="mainBonds.length > 0">
                            <div class="dash-card-scroll">
                                <table>
                                    <thead>
                                        <tr class="alternative-header">
                                            <th>Fundo</th>
                                            <th *ngIf="!isShareholder">
                                                Coobrigação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let bond of mainBonds">
                                            <td>
                                                <div class="dash-card-item">
                                                    <div
                                                        class="dash-card-item-initials">
                                                        <span>{{getFundInitials(bond)}}</span>
                                                    </div>

                                                    <app-spacer
                                                        [right]="16"></app-spacer>

                                                    <div
                                                        class="dash-card-item-content">
                                                        <div
                                                            class="dash-card-item-content-title">
                                                            {{bond.name ??
                                                            bond.short_name}}
                                                        </div>
                                                        <div
                                                            class="dash-card-item-content-subtitle">
                                                            {{formatCnpj(bond.document)}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style="padding:0 10px"
                                                *ngIf="!isShareholder">
                                                {{bond.coobligation ? 'Sim' :
                                                'Não'}}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <app-spacer [bottom]="28"></app-spacer>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="!mainLoading && !approvalService.approvalData.mainVersion">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>
            </ng-container>
        </div>

        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <ng-container *ngIf="comparingDataLoading || comparingLoading">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!comparingDataLoading && !comparingLoading">
                <ng-container
                    *ngIf="approvalService.approvalData.comparingVersion">
                    <div class="dash-card card-padding-top">
                        <app-empty-content
                            [isVisible]="comparingBonds.length === 0"
                            title="Nenhum vinculo encontrado"
                            description="Não foi encontrado nenhum vinculo nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <div class="dash-card-body"
                            *ngIf="comparingBonds.length > 0">
                            <div class="dash-card-scroll">
                                <table>
                                    <thead>
                                        <tr class="alternative-header">
                                            <th>Fundo</th>
                                            <th *ngIf="!isShareholder">
                                                Coobrigação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let bond of comparingBonds"
                                            [class]="bond.compareClass"
                                            [style.text-decoration]="bond.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                            <td>
                                                <div class="dash-card-item"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <img
                                                        *ngIf="bond.compareClass === 'row-compare-added'"
                                                        src="/assets/images/carbon-checkmark.svg"
                                                        class="comparison-icon" alt="adicionado" />
                                                    <img
                                                        *ngIf="bond.compareClass === 'row-compare-removed'"
                                                        src="/assets/images/carbon-error-warning.svg"
                                                        class="comparison-icon" alt="removido" />
                                                    <img
                                                        *ngIf="bond.compareClass === 'row-compare-modified'"
                                                        src="/assets/images/carbon-warning.svg"
                                                        class="comparison-icon me-2" alt="novo" />
                                                    <div
                                                        style="display: flex; align-items: center;">
                                                        <div
                                                            class="dash-card-item-initials">
                                                            <span>{{getFundInitials(bond)}}</span>
                                                        </div>

                                                        <app-spacer
                                                            [right]="16"></app-spacer>

                                                        <div
                                                            class="dash-card-item-content">
                                                            <div
                                                                class="dash-card-item-content-title">
                                                                <img
                                                                    *ngIf="bond.compareClass === 'row-compare-modified' && isFieldChanged(bond, 'name')"
                                                                    src="/assets/images/carbon-warning.svg"
                                                                    class="comparison-icon me-2" alt="alterado" />
                                                                {{bond.name ??
                                                                bond.short_name}}
                                                            </div>
                                                            <div
                                                                class="dash-card-item-content-subtitle">
                                                                <img
                                                                    *ngIf="bond.compareClass === 'row-compare-modified' && isFieldChanged(bond, 'document')"
                                                                    src="/assets/images/carbon-warning.svg"
                                                                    class="comparison-icon me-2" alt="alterado" />
                                                                {{formatCnpj(bond.document)}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style="padding:0 10px"
                                                *ngIf="!isShareholder">
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <img
                                                        *ngIf="bond.compareClass === 'row-compare-modified' && isFieldChanged(bond, 'coobligation')"
                                                        src="/assets/images/carbon-warning.svg"
                                                        class="comparison-icon me-2" alt="alterado" />
                                                    <span>
                                                        {{bond.coobligation ?
                                                        'Sim' : 'Não'}}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <app-spacer [bottom]="28"></app-spacer>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="!approvalService.approvalData.comparingVersion && !comparingDataLoading && !comparingLoading">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>